function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { cx } from '@emotion/css';
import { popupStyle, triggerPrefix } from "./style";
import useThemeProps from "../../hooks/useThemeProps";
var Popup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _getPopupContainer;

  var _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? triggerPrefix() : _props$prefixCls,
      className = props.className,
      style = props.style,
      target = props.target,
      arrow = props.arrow,
      open = props.open,
      autoDestroy = props.autoDestroy,
      popup = props.popup,
      getPopupContainer = props.getPopupContainer,
      offsetX = props.offsetX,
      offsetY = props.offsetY,
      ready = props.ready,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      mask = props.mask,
      maskClosable = props.maskClosable;
  var theme = useThemeProps();

  var _React$useState = React.useState(open),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      shouldRender = _React$useState2[0],
      setShouldRender = _React$useState2[1]; // do not render before first open


  useEffect(function () {
    if (open) {
      setShouldRender(true);
    }
  }, [open]); // ======================= Container ========================

  var getPopupContainerNeedParams = Boolean((getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer.length) && getPopupContainer.length > 0);

  var _useState = useState(!getPopupContainer || !getPopupContainerNeedParams),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1]; // Delay to show since `getPopupContainer` need target element


  useLayoutEffect(function () {
    if (!show && getPopupContainerNeedParams && target) {
      setShow(true);
    }
  }, [show, getPopupContainerNeedParams, target]);
  if (!shouldRender || !show) return null;
  if (!open && autoDestroy === true) return null;
  var offsetStyle = ready || !open ? {
    left: offsetX,
    top: offsetY
  } : {
    left: '-1000vw',
    top: '-1000vh'
  };

  var getPopEl = function getPopEl() {
    var popupInner;

    if (typeof popup === 'function') {
      popupInner = popup();
    } else {
      popupInner = popup;
    }

    return /*#__PURE__*/React.createElement("div", null, mask && open && /*#__PURE__*/React.createElement("div", {
      className: "prism-popup-mask",
      style: {
        background: maskClosable ? 'transparent' : theme.third
      }
    }), /*#__PURE__*/React.createElement("div", {
      ref: ref,
      className: cx("".concat(prefixCls, "-popup"), popupStyle(theme, prefixCls), className),
      style: _objectSpread(_objectSpread(_objectSpread({}, style), offsetStyle), {}, {
        // 为了在二次渲染时，能够拿到popup的宽高，强制display不为none，可能有更好的办法
        display: open ? 'block' : undefined
      }),
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, arrow && /*#__PURE__*/React.createElement("div", {
      className: cx("".concat(prefixCls, "-popup-arrow"), arrow.className, 'prism-popup-arrow'),
      style: {
        left: arrow.x,
        top: arrow.y
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-popup-inner")
    }, popupInner)));
  };

  var portal = /*#__PURE__*/createPortal(getPopEl(), (_getPopupContainer = getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer(target)) !== null && _getPopupContainer !== void 0 ? _getPopupContainer : document.body);
  return portal;
});
Popup.displayName = 'Popup';
export default /*#__PURE__*/React.memo(Popup);